// extracted by mini-css-extract-plugin
var _1 = "CardForm_active__c8559";
export { _1 as "active" }
